<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{ name: string; size?: number }>(), { size: 22 })

const paths: Record<string, string[]> = {
  menu: ['M4 7h16M4 12h16M4 17h16'],
  search: ['m21 21-4.35-4.35', 'M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z'],
  plus: ['M12 5v14M5 12h14'],
  folder: ['M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z'],
  chevron: ['m9 18 6-6-6-6'],
  edit: ['M12 20h9', 'M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4L16.5 3.5Z'],
  trash: ['M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v5M14 11v5'],
  camera: ['M4 7h3l2-3h6l2 3h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2Z', 'M16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z'],
  upload: ['M12 16V4m0 0-5 5m5-5 5 5', 'M4 15v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4'],
  download: ['M12 4v12m0 0 5-5m-5 5-5-5', 'M4 19h16'],
  image: ['M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z', 'm3 16 5-5 4 4 3-3 6 6', 'M8.5 8.5h.01'],
  close: ['M6 6l12 12M18 6 6 18'],
  rotateLeft: ['M4 4v6h6', 'M5.5 15a7 7 0 1 0 1.8-7.4L4 10'],
  rotateRight: ['M20 4v6h-6', 'M18.5 15a7 7 0 1 1-1.8-7.4L20 10'],
  check: ['m5 12 4 4L19 6'],
  all: ['M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z'],
  storage: ['M4 6c0-1.1 3.6-2 8-2s8 .9 8 2-3.6 2-8 2-8-.9-8-2Z', 'M4 6v6c0 1.1 3.6 2 8 2s8-.9 8-2V6M4 12v6c0 1.1 3.6 2 8 2s8-.9 8-2v-6'],
  tag: ['M20 13 13 20l-9-9V4h7l9 9Z', 'M8.5 8.5h.01'],
  arrowLeft: ['M19 12H5m0 0 6 6m-6-6 6-6'],
  switch: ['M7 7h11l-3-3m3 3-3 3M17 17H6l3 3m-3-3 3-3'],
  info: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z', 'M12 10v6M12 7h.01'],
  warning: ['M12 3 2 21h20L12 3Z', 'M12 9v5M12 18h.01']
}

const selected = computed(() => paths[props.name] ?? paths.info)
</script>

<template>
  <svg
    class="app-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path v-for="path in selected" :key="path" :d="path" />
  </svg>
</template>
